const generateStreamKey = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
}

export const key = 'cam-streams'

export const module =  {
  namespaced: true,
  state:() => ({
     streams: []
  }),
  mutations:{
    addStream(state, props){
      state.streams.push(props)
    },
    removeStream(state, key){
      state.streams = state.streams.filter( stream => stream.key !== key)
    }
  },
  actions:{
    startLive({ commit }, payload){
      commit('addStream', {
        key: generateStreamKey(),
        isLive: true,
        device: payload.device
      })
    },
    startPlayback({ commit }, payload){
      commit('addStream', {
        key: generateStreamKey(),
        isLive: false,
        device: payload.device,
        from:payload.from,
        to:payload.to
      })
    },
    closeStream({ commit }, payload){
      commit('removeStream', payload.key)
    }
  },
  getters:{
    streams(state){
      return state.streams
    }
  }
};

export default { key, module }
